import {
  FULFILLMENT_STATUSES,
  ORDER_METHODS,
  PaymentMethods,
  REFUND_REASONS,
  ROOM_SERVICE_LOCATION_TYPES,
} from '../../../../../services/exports/Constants';
import { OFFER_KIND } from '../../../../../views/menu/offers/constants';

export default {
  title: 'Détails de la commande',
  sections: {
    driver_info: 'Infos livreur',
    order_info: 'Infos commande',
    price_info: 'Infos prix',
    adjustments: 'Ajustements',
  },
  order_methods: {
    [ORDER_METHODS.pickup]: 'À emporter',
    [ORDER_METHODS.delivery]: 'Livraison',
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: 'Service en chambre',
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: 'Service à table',
  },
  room_service_location_types: {
    [ROOM_SERVICE_LOCATION_TYPES.room_service]: {
      details_label: 'N° de chambre',
    },
    [ROOM_SERVICE_LOCATION_TYPES.table_service]: {
      details_label: 'N° de table',
    },
  },
  fulfillment_statuses: {
    [FULFILLMENT_STATUSES.created]: "Cette commande est en attente d'approbation",
    [FULFILLMENT_STATUSES.reviewed]: "Cette commande est en attente d'approbation",
    [FULFILLMENT_STATUSES.accepted]: 'Cette commande est en cours de traitement',
    [FULFILLMENT_STATUSES.preparing]: 'Cette commande est en cours de traitement',
    [FULFILLMENT_STATUSES.ready]: 'Cette commande est prête à être récupérée par le client',
    [FULFILLMENT_STATUSES.on_delivery]: 'Cette commande est en cours de livraison au client',
    [FULFILLMENT_STATUSES.picked]: 'Cette commande a été traitée avec succès',
    [FULFILLMENT_STATUSES.rejected]: 'Cette commande a été rejetée et remboursée',
    default: 'Cette commande a été traitée avec succès',
  },
  adjustment_reasons: {
    [REFUND_REASONS.RequestedByCustomer]: 'Demandé par le client',
    [REFUND_REASONS.Reclamation]: 'Réclamation',
    [REFUND_REASONS.CommunicationError]: 'Erreur de communication',
    [REFUND_REASONS.Other]: 'Autre',
    [REFUND_REASONS.Dispute]: 'Litige client',
    dispute_win: 'Litige client gagné',
    null: '',
    undefined: '',
  },
  labels: {
    order_note: 'Note de commande',
    discount: 'Remise',
    driver_name: 'Nom du livreur',
    driver_phone_number: 'Tél. livreur',
    pin_code: 'PIN',
    invoice_payment: 'Paiement par facture',
    paid_in_cash: 'Paiement en espèces',
    customer_paid_online: 'Client a payé en ligne',
    phone: 'Tél',
    email: 'Email',
    points_used: 'Cette commande inclut une récompense de fidélité utilisée par un client fidèle',
    delivery: 'Livraison',
    pickup: 'À emporter',
    original: 'Original',
    delivery_fee: 'Frais de livraison',
    tip: 'Pourboire',
    service_fee: 'Traitement en ligne',
    payment_method_upcharge_fee: {
      [PaymentMethods.PAYPAL]: 'Frais PayPal',
    },
    discount_breakdown: {
      [OFFER_KIND.PERCENTAGE_OFF_BY_MIN_SPEND_VALUE]: 'Remise en % sur le total appliquée',
      [OFFER_KIND.PERCENTAGE_OFF_BY_PRODUCTS]: 'Remise en % sur les produits appliquée',
      [OFFER_KIND.AMOUNT_OFF_BY_PRODUCTS]: 'Remise fixe sur les produits appliquée',
      [OFFER_KIND.AMOUNT_OFF_BY_MIN_SPEND_VALUE]: 'Remise fixe sur le total appliquée',
      [OFFER_KIND.BOGO]: 'BOGO appliqué',
      [OFFER_KIND.BOGO_HALF_PRICE]: 'Promo BOGO demi-prix appliquée',
      [OFFER_KIND.FREE_ITEM_BY_PRODUCTS]: 'Article gratuit par produits appliqué',
      [OFFER_KIND.FREE_ITEM_BY_MIN_SPEND_VALUE]: 'Article gratuit par total appliqué',
      GiftCard: 'Carte cadeau appliquée',
      Reward: 'Points de fidélité appliqués',
      CashbackAccount: 'Points de fidélité appliqués',
      PromoCodeComponent: 'Promotion appliquée',
      Offer: 'Offre appliquée',
    },
    total_discount: 'Promotion appliquée',
    tax: 'Taxes',
    total: 'Total',
    today: "Aujourd'hui",
  },
  schedule: {
    header: 'Prévu pour le {{date}} à {{time}}',
    text: 'Nous vous rappellerons quand il sera temps de préparer la commande',
  },
};
